<template>
    <div class="warning">
        <van-overlay class="overlay" :show="show" @click="hidewarning" :z-index="999">
            <div class="warning-wrapper flex-column align-center" @click.stop>
                <img class="warning-header-img" :src="pageImg" alt="" @click="toDetail" />
                <!-- <img class="warning-header-btn" @click="experienceGoldDetail" src="@/assets/images/mine/button.png" alt="" /> -->
            </div>
            <div class="close" @click="hidewarning">
                <img src="@/assets/images/close.png" alt="" />
            </div>
        </van-overlay>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: "prizeDraw",

    props: {
        show: {
            type: Boolean,
            default: false,
        },
        content: String,
    },

    computed: {
        ...mapGetters({ appEnv: 'getAppEnv' })
    },
    data() {
        return {
            pageImg: require("@/assets/images/mine/prizeDraw.png"),
        };
    },
    methods: {
        handleShowwarning() {
            this.$emit("update:show");
        },
        hidewarning() {
            this.$emit("update:show", false);
        },
        handleConfirm() {
            this.$emit("handleConfirm");
        },
        comfirm() {
            this.$emit("comfirm");
        },

        toDetail() {
            if (this.appEnv.appEnv == 'miniprogram') {
                wx.miniProgram.navigateTo({
                    url: `/pages/prizeDraw/prizeDraw`,
                });
            }
            else {
                window.location.href = 'https://33296460-3.hd.ysfaisco.cn/33296460/CycRmx07SuY2clmzRrccsw/load-33296460-3.html?style=115&editQrcode=true&_source=1'
            }
        },
    },
};
</script>

<style lang="less" scoped>
.warning {
    .overlay {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .warning-wrapper {
        width: 100%;
        height: 100%;
        border-radius: 20px;

        margin-top: -300px;
        .warning-header-img {
            width: 100%;
            height: 100%;
        }
        .warning-header-btn {
            width: 257px;
            height: 73px;
            margin-top: -140px;
            cursor: pointer;
        }
        .warning-result {
            font-size: 36px;
            color: #212121;
            margin: 48px 0;
        }
        .warning-description {
            font-size: 30px;
            color: #616161;
            line-height: 40px;
            padding: 0 38px;
        }
        .warning-confirm-btn {
            width: 512px;
            height: 70px;
            color: #fff;
            background-image: linear-gradient(90deg, #009af3 0%, #00c6ea 100%);
            margin-top: 50px;
            font-size: 32px;
            padding: 0 38px;
        }
    }
    .close {
        position: absolute;
        bottom: calc(50vh - 292px - 56px - 50px);
        left: 0;
        right: 0;
        margin: auto;
        width: 72px;
        height: 72px;
        img {
            width: 100%;
            height: 100%;
        }
    }
}
</style>
